import a from"./_assocIndexOf.js";var r=a;var t=function(a){var t=this.__data__,o=r(t,a);return o<0?void 0:t[o][1]};export{t as default};
//# sourceMappingURL=_listCacheGet.js.map
